// Runtime capability detection. Never UA-sniff (SKILL gate 3).

export interface ComputeCaps {
  webgpu: boolean;
  crossOriginIsolated: boolean;
  hardwareConcurrency: number;
}

export async function detectComputeCaps(): Promise<ComputeCaps> {
  let webgpu = false;
  try {
    const gpu = (navigator as Navigator & { gpu?: { requestAdapter(): Promise<unknown> } }).gpu;
    if (gpu) webgpu = (await gpu.requestAdapter()) !== null;
  } catch {
    webgpu = false;
  }
  return {
    webgpu,
    crossOriginIsolated: globalThis.crossOriginIsolated === true,
    hardwareConcurrency: navigator.hardwareConcurrency || 2,
  };
}

export function supportsVideoFrameCallback(): boolean {
  return 'requestVideoFrameCallback' in HTMLVideoElement.prototype;
}

export function supportsVibrate(): boolean {
  return typeof navigator.vibrate === 'function';
}
